var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1062.75 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 531.38,
    y1: 1055.33,
    x2: 531.38,
    y2: 187.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00abe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893ae4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 531.38,
    y1: 1055.33,
    x2: 531.38,
    y2: 187.83,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M531.38,591.92c232.31,0,433.66,165.11,478.75,392.58,2.85,14.37-3.55,24.82-7.61,29.77-7.2,8.77-17.82,13.8-29.14,13.8H89.38c-11.32,0-21.94-5.03-29.14-13.8-4.06-4.95-10.46-15.4-7.61-29.77,45.09-227.48,246.44-392.58,478.75-392.58M531.38,540c-262.1,0-480.59,186.73-529.68,434.41-10.85,54.75,31.86,105.59,87.68,105.59h884c55.82,0,98.54-50.83,87.68-105.59-49.1-247.68-267.58-434.41-529.68-434.41h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.38,51.92c107.34,0,194.66,87.32,194.66,194.66s-87.33,194.67-194.66,194.67-194.66-87.32-194.66-194.67,87.33-194.66,194.66-194.66M531.38,0c-136.19,0-246.59,110.4-246.59,246.58s110.4,246.59,246.59,246.59,246.59-110.4,246.59-246.59S667.56,0,531.38,0h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.d5b960115f56e2a35f491ace01e0d363.svg";
export { ForwardRef as ReactComponent };